import { withAuthenticationRequired } from "@auth0/auth0-react"
import React from "react"
import Loading from "../Loading/Loading"

export const ProtectedRoute = ({ component: Component }) => {
	const domain = process.env.REACT_APP_AUTH0_DOMAIN
	const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
	const isDev = process.env.NODE_ENV === "development" || !domain || !clientId

	if (isDev) {
		// Modo desenvolvimento / sem chaves Auth0: permite acesso direto
		return <Component />
	}

	const AuthProtected = withAuthenticationRequired(Component, {
		onRedirecting: () => <Loading />,
	})

	return <AuthProtected />
}